<template>
    <div class="main comp-main">
        <div class="main-header-con" id="header_bar">
            <div class="main-header">
                <a class="main-header-left-logo" :style="bg" href="https://p.diantiyun.com"></a>
                <div class="header-avator-con">
                    <div class="user-dropdown-menu-con">
                        <ul>
                            <router-link to="/home">
                                <li><span>{{$t('l.home')}}</span></li>
                            </router-link>
                            <li v-for="(item,index) in navItemList" :key="index" @mouseleave="ifShowNav = false">
                                <Poptip placement="bottom" trigger="hover" :transfer="true">
                                    <span>{{$t(item.title)}}</span>
                                    <div slot="content">
                                        <nav-options :navTabList="item.children"
                                                     @on-change="handleOption"></nav-options>
                                    </div>
                                </Poptip>
                            </li>
                            <router-link to="/explain">
                                <li><span>{{$t('l.explain')}}</span></li>
                            </router-link>
                        </ul>
                        <!-- 导航栏 最右侧-->
                        <div class="user-dropdown-menu-con-avatar">
                            <div class="icon-status">
                                <!-- 故障到期 -->
<!--                                <div v-if="$store.state.index.data.faultCount" class="icon-status-div">-->
<!--                                    <img @click="goFaults"-->
<!--                                         src="../../public/images/index/header/gzalarm_over.png"-->
<!--                                         :title="$t('l.current_fault')+ ' '+ $store.state.index.data.faultCount">-->
<!--                                    <span>{{$store.state.index.data.faultCount>=99?'99+':$store.state.index.data.faultCount}}</span>-->
<!--                                </div>-->
<!--                              2025年10月14日 去掉故障数量-->
<!--                                <div v-if="$store.state.index.data.ExpireCount" class="icon-status-div">-->
<!--                                    <img @click="()=>{$router.push({name:'page_sim'})}"-->
<!--                                         src="/images/index/header/qfalarm_up.png"-->
<!--                                         :title="$t('l.sim_over') + ' ' + $store.state.index.data.ExpireCount">-->
<!--                                    <span>{{$store.state.index.data.ExpireCount>=99?'99+':$store.state.index.data.ExpireCount}}</span>-->
<!--                                </div>-->
                                <!-- 设备到期时间 -->
                                <!--<div  class="icon-status-div">-->
                                <!--<img @click="endTimeDeviceModal.show=true,loadDataEndTimeDevice(1)" src="../../public/images/index/header/end_time_device.png" :title="$t('l.deadline') + ' ' + 10">-->
                                <!--<span>{{$store.state.index.data.ExpireCount>=99?'99+':$store.state.index.data.ExpireCount}}</span>-->
                                <!--</div>-->
                                <!--<div v-if="$store.state.index.data.helpCount!=0" class="icon-status-div">-->
                                <!--<img src="../../public/images/index/header/kralarm_up.png" :title="'发起求救'+$store.state.index.data.helpCount+'台'">-->
                                <!--<span>{{$store.state.index.data.helpCount>=99?'99+':$store.state.index.data.helpCount}}</span>-->
                                <!--</div>-->
                                <!-- 困人故障 -->
<!--                                <div v-if="$store.state.index.data.tiringCount" class="icon-status-div">-->
<!--                                    <img style="margin: 0;" @click="modal.show=true,loadData(1)"-->
<!--                                         src="/images/index/header/kralarm_up.png"-->
<!--                                         :title="this.$t('l.lift_trapped') + '' + $store.state.index.data.tiringCount">-->
<!--                                    <span>{{$store.state.index.data.tiringCount>=99?'99+':$store.state.index.data.tiringCount}}</span>-->
<!--                                </div>-->
                            </div>
                            <div>
                                <task-center></task-center>
                            </div>
                            <!--<Dropdown class="margin-left-5 margin-right-5" @on-click="changeLanguage" trigger='click' transfer>-->
                            <!--<div class="guoji">-->
                            <!--<Icon type="md-globe"  size="22" style="color: white"/>-->
                            <!--</div>-->
                            <!--<DropdownMenu slot="list">-->
                            <!--<DropdownItem name="zh-CN">中文</DropdownItem>-->
                            <!--<DropdownItem name="en-US">English</DropdownItem>-->
                            <!--</DropdownMenu>-->
                            <!--</Dropdown>-->
                            <div class="user-name">
                                <Avatar class="user-info-head" @click.native="personalInfoShow=!personalInfoShow"
                                        :src="$store.state.user&&$store.state.user.user&&$store.state.user.user.head_url?$store.state.user.user.head_url:'https://static.diantiyun.com/upload/image/avatar.png'"/>
                            </div>
                            <div class="user-info-marks" v-if="$store.state.user.user">
                                <Tooltip placement="top" transfer :content="$store.state.user.user.realname">
                                    <span class="user-name" @click="personalInfoShow=true">{{$store.state.user.user.realname}}</span>
                                </Tooltip>
                            </div>
                            <!-- 中英文切换 -->
<!--                            <div @click="changeLanguage" class="language-box">-->
<!--                                {{showLanguage}}-->
<!--                            </div>-->

                          <Dropdown @on-click="changeLanguage" trigger="click" placement="bottom" transfer class="margin-left-10">
                            <a href="javascript:void(0)" style="color: #fff">
                              {{showLanguage}}
                              <Icon type="ios-arrow-down"></Icon>
                            </a>
                            <DropdownMenu  slot="list">
                              <DropdownItem name="zh-CN">简体中文</DropdownItem>
                              <DropdownItem name="en-US">English</DropdownItem>
                              <DropdownItem name="pt-PT">Português</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                    </div>
                </div>
                <!--显示导航对应的按钮页面 -->
                <div class="main-header-nav-container" v-if="ifShowNav" @mouseenter="ifShowNav=true"
                     @mouseleave="ifShowNav=false">
                    <div class="main-header-nav-container-triangle" :style="{left:triangleSpace+'px'}"></div>
                    <div class="main-header-nav-container-item">
                        <nav-options :navTabList="navTabList" @on-change="handleOption"></nav-options>
                    </div>
                </div>
            </div>

        </div>
        <!-- 底部 -->
        <div class="single-page-con">
            <div class="single-page">
                <keep-alive :include="cachePage">
                    <router-view></router-view>
                </keep-alive>
                <!--版权所有-->
                <div class="single-page-bottom">
                    <Row>
                        Copyright © {{new Date().getFullYear()}} diantiyun.com All Rights Reserved. 电梯云 版权所有 <a
                            style="color:#515a6e" href="http://www.beian.miit.gov.cn/">辽ICP备 19006816号-2</a>
                    </Row>
                </div>
            </div>
        </div>
        <!-- 求救弹出框 -->
        <template>
            <lg-modal class="ivu-modal-body" :show="isCallHelp" :fullscreen="true" :closable="false"
                      :title="$t('l.hint64')">
                <div style="width: 100%;height: 14000px;display: flex;justify-content: center;background-color: #000">
                    <div id="save-videos">
                        <div v-if="isCallHelp" class="video-cell" style="height: 400px;width: 400px;">
                            <video id="me" class="other-video"></video>
                            <div class="video-room"
                                 style="position: relative;color: #fff;font-weight: bold;bottom: 40px;left: 20px;">
                                <span>{{$t('l.dty_platform')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <Button type="error" @click="quit">{{$t('l.close')}}</Button>
                </div>
            </lg-modal>
            <!--困人、求救  统计 -->
            <lg-modal :show="modal.show" :styles="{top:'50px'}" :title="$t('l.trap_persons')"
                      :confirm-text="$t('l.close')" :width="1300" @on-submit="modal.show=false"
                      @on-cancel="modal.show=false" :show-cancel="false">
                <Row>
                    <Row>
                        <Table border max-height="500" :columns="getColumns" :data="modal.table.data"></Table>
                    </Row>
                </Row>
                <Row type="flex" justify="center">
                    <Page size="small"
                          :current="modal.table.page.current"
                          :page-size="modal.table.page.size"
                          :total="modal.table.page.total"
                          show-elevator show-total
                          @on-page-size-change="($event)=>{modal.table.page.size = $event,loadData(1)}"
                          @on-change="loadData">
                    </Page>
                </Row>
            </lg-modal>
        </template>
        <!-- 我的个人信息 -->
        <template>
            <Drawer class-name="drawer-person" :title="$t('l.person_info')" width="350" :closable="false"
                    v-model="personalInfoShow">
                <login-info></login-info>
            </Drawer>
        </template>
        <!-- 到期设备 -->
    </div>
</template>

<script>
    import navOptions from './main-components/nav-options.vue'
    import util from '@/libs/util.js';
    import ws from '@/libs/websocket.js';
    import LoginInfo from "./main-components/login-info";
    import newWebRTC from "../libs/new-webrtc"
    import TaskCenter from "./main-components/task-center";
    import lgModal from "../../src/views/my-components/lg-modal"

    export default {
        components: {
            TaskCenter,
            LoginInfo,
            navOptions,
            lgModal
        },
        data() {
            return {
                personalInfoShow: false,//显示个人信息
                count: 1,
                isFullScreen: false,
                triangleSpace: 48,
                ifShowNav: false,
                openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
                navTabList: [],
                navSpanStyle: {},
                helpWprders: [],
                percent: 0,// 进度
                ifShowProgressTable: false, // 是否展示进度条列表
                mainDeviceBadgeNumber: 0,
                companyTasks: [],
                modal: {
                    show: false,
                    action: 0,
                    table: {
                        data: [],
                        loading: false,
                        columns: [],
                        page: {
                            current: 1,  // 当前页码
                            size: 12, // 每页个数
                            sizeOptions: [12, 18, 24],
                            total: 0,
                            sortKey: 'id',
                            sortMethod: 'desc',
                            keyword: ''
                        }
                    }
                },
                endTimeDeviceModal: {
                    show: false,
                    table: {
                        data: [],
                        loading: false,
                        columns: [],
                        page: {
                            current: 1,  // 当前页码
                            size: 12, // 每页个数
                            sizeOptions: [12, 18, 24],
                            total: 0,
                            sortKey: 'id',
                            sortMethod: 'desc',
                            keyword: ''
                        }
                    }
                }
            };
        },
        computed: {
            getColumns() {
                return [
                    {
                        title: this.$t('l.elevator_name'),
                        key: "name",
                        align: "center",
                    },
                    {
                        title: this.$t('l.terminal_id'),
                        key: "device_name",
                        align: "center",
                        width: 200
                    },

                    {
                        title: this.$t('l.device_model'),
                        key: "model",
                        align: "center",
                        width: 200
                    },
                    {
                        title: this.$t('l.fault_code'),
                        key: "fault_no",
                        align: "center",
                        width: 80
                    },
                    {
                        title: this.$t('l.occur_time'),
                        key: "occur_time",
                        align: "center",
                        width: 200
                    },
                    {
                        title: this.$t('l.alarm_mobile'),
                        key: "j_alarm_charger",
                        align: "center",
                        width: 300,
                        render: (h, p) => {
                            var html = "";
                            var j_alarm_chargers = p.row.j_alarm_charger;
                            if (j_alarm_chargers) {
                                j_alarm_chargers.forEach(elem => {
                                    html += elem;
                                    html += "</br>";
                                })
                            }
                            return h("div", {
                                domProps: {
                                    innerHTML: html
                                }
                            });
                        }
                    }
                ]
            },
            isCallHelp() {
                return this.$store.state.app.isCallHelp
            },
            bg() {
                let user = this.$store.state.user.user;
                if (!user) return {background: ''};
                if (user.current_logo) {
                    return {
                        background: `url('${user.current_logo}') no-repeat center`
                    };

                } else {
                    return {
                        background: `url('https://static.diantiyun.com/logo.png?a=2') no-repeat center`
                    };
                }
            },
            userName() {
                let loginAdmin = this.$store.state.app.admin;
                return loginAdmin.real_name || loginAdmin.user_name;
            },
            navItemList() {
                return this.$store.state.app.menuList;
            },
            cachePage() {
                return this.$store.state.app.cachePage;
            },
            faultList() {
                return this.$store.state.fault.faultList;
            },
            showLanguage() {
              let language = localStorage.getItem('language');
              let languageText="";
              switch (language){
                case "en-US":
                  languageText="English";
                  break;
                case "pt-PT":
                  languageText="Português";
                  break;
                default:
                  languageText="简体中文";
                  break;
              }
              return languageText;
            }
        },
        methods: {
            init() {
                util.ajax.get('/settings/get').then(res => {
                    if (res && !res.code) {
                        util.parseJSONResult(res.data);
                        this.$store.state.app.lift_state_param_settings = res.data
                    }
                })
            },
          goFaults(){

            if(this.$route.name != "page_fault"){
              this.$router.push({name:'page_fault'})
            }else{
              console.log(1);
              util.page_fault.loadData(1);
            }

          },
            handleOption(item) {
                this.$router.push({
                    name: item.name
                });
            },
            clear() {
                this.$store.commit('clearAll');
            },
            quit() {
                if (newWebRTC.connections) {
                    this.$Modal.confirm({
                        title: this.$t('l.warn'),
                        content: this.$t('l.hint35'),
                        okText: this.$t('l.close'),
                        cancelText: this.$t('l.cancel'),
                        onOk: () => {
                            if (newWebRTC.socket) newWebRTC.socket.close();
                            this.$store.commit('callHelp', false);
                        }
                    })
                } else {
                    if (newWebRTC.socket) newWebRTC.socket.close()
                    this.$store.commit('callHelp', false);
                }
            },
            updateIndexData(message) {
                this.$store.commit('updateIndex', message);
            },
            loadData(page = 1) {
                this.modal.table.loading = true
                util.ajax.get("/fault/tiringlist", {
                    params: {
                        page: page || this.modal.table.page.current,
                        size: this.modal.table.page.size,
                        orderKey: this.modal.table.page.sortKey,
                        orderMethod: this.modal.table.page.sortMethod,
                        keyword: this.modal.table.page.keyword,
                    }
                }).then(res => {
                    if (!res.code) {
                        this.setPage(res.data)
                    }
                    this.modal.table.loading = false
                })
            },
            setPage(pageInfo) {
                this.modal.table.data = pageInfo.list.map(elem => {
                    elem.occur_time = new Date(elem.occur_time).pattern("yyyy-MM-dd HH:mm:ss");
                    if (elem.j_alarm_charger && elem.j_alarm_charger.length) {
                        elem.j_alarm_charger = JSON.parse(elem.j_alarm_charger);
                        elem.j_alarm_charger = elem.j_alarm_charger.map(alarm_charger => {
                            return `${alarm_charger.name}-${alarm_charger.mobile}`;
                        })
                    } else {
                        elem.j_alarm_charger = this.$t('l.remark194');
                    }
                    return elem;
                });
                this.modal.table.page.current = pageInfo.pageNumber;
                this.modal.table.page.total = pageInfo.totalRow;
            },
            changeLanguage(language) {
              this.$i18n.locale = language   //设置中英文模式
              localStorage.setItem('language', language);
              util.ajax.get('changelang', {
                  params: {
                      language
                  }
              }).then(res => {
                  location.reload()
              })
                // let language = localStorage.getItem("language");
                // if (language && language == "en-US") {
                //     language = "zh-CN";
                // } else {
                //     language = "en-US";
                // }
                // this.$i18n.locale = language   //设置中英文模式
                // localStorage.setItem('language', language);
                // util.ajax.get('changelang', {
                //     params: {
                //         language: language
                //     }
                // }).then(res => {
                //     location.reload()
                // })
            },
            //    加载导航栏上三个故障数量
            loadIndextreeData() {
                util.ajax.get('/indextree').then(res => {
                    if (res && !res.code) {
                        this.$store.commit('setIndex', res.data);
                    }
                })
            }
        },
        watch: {
            '$route'(to) {
                this.$store.commit('setCurrentPageName', to.name);
                localStorage.currentPageName = to.name;
            },
        },
        mounted() {
            ws.on('updateIndexData', this.updateIndexData.bind(this), 0);
        },
        created() {
            this.$store.commit('setFaultList');
            if (!this.$store.state.user.user) util.init();
            this.init();
            ws.init();
            this.loadIndextreeData();
        },
        destroyed() {
            if (newWebRTC.socket) newWebRTC.socket.close();
            ws.close();
        }
    };
</script>

<style lang="less">
    @header-height: 50px;

    a:visited {
        color: #00b7d3;
    }

    .lock-screen-back {
        border-radius: 50%;
        z-index: -1;
        box-shadow: 0 0 0 0 #667aa6 inset;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: all 3s;
    }

    .main {
        position: absolute;
        width: 100%;
        height: 100%;
        min-width: 1000px;
        overflow-x: hidden;
        /*background-color: #dfecf4;*/
        ul, li, a {
            list-style: none;
        }
        .unlock-con {
            width: 0px;
            height: 0px;
            position: absolute;
            left: 50%;
            top: 50%;
            z-index: 11000;
        }
        .sidebar-menu-con {
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 21;
            transition: width .3s;
            background: rgb(73, 80, 96)
        }
        .layout-text {
            display: inline-block;
            white-space: nowrap;
            position: absolute;
        }
        .main-hide-text .layout-text {
            display: none;
        }
        &-content-container {
            position: relative;
        }
        &-header-con {
            box-sizing: border-box;
            position: fixed;
            display: block;
            width: 100%;
            height: @header-height;
            z-index: 20;
            padding-left: 0px !important;
            transition: padding .3s;
            .main-header {
                height: @header-height;
                &-nav-container {
                    box-sizing: border-box;
                    position: absolute;
                    z-index: 3000;
                    width: 35%;
                    height: 300px;
                    left: 40%;
                    box-shadow: 15px 15px 10px -15px #000;
                    border-radius: 0 0 4px 4px;
                    &-triangle {
                        height: 20px;
                        width: 20px;
                        transform: rotateZ(45deg);
                        background: white;
                        position: absolute;
                        top: -8px;
                    }
                    &-item {
                        width: 100%;
                        height: 100%;
                        background: white;
                        position: absolute;
                        z-index: 3001;
                    }
                }
            }
        }
        &-breadcrumb {
            padding: 8px 15px 0;
        }
        &-menu-left {
            background: #464c5b;
        }

        &-header {
            overflow: hidden;
            height: 60px;
            background: #fff;
            box-shadow: 0 2px 1px 1px rgba(100, 100, 100, .1);
            position: relative;
            display: flex;
            align-items: center;
            z-index: 11;
            .navicon-con {
                margin: 6px;
                display: inline-block;
            }
            .main-header-left-logo {
                /*width: 16%;*/
                min-width: 200px;
                width: 200px;
                height: 40px;
                border-radius: 4px;
                background-size: auto 100%;
                cursor: pointer;
                display: block;
                margin-left: 5px;
                /*background: no-repeat center;*/
            }
            /*.logo-diantiyun{*/
            /*background: url(../../public/images/logo.png) ;*/
            /*}*/
            /*.logo-bolang{*/
            /*background: url(../../public/images/index/logo_bolang.png) no-repeat center;*/
            /*}*/
            .header-middle-con {
                position: absolute;
                left: 60px;
                top: 0;
                right: 340px;
                bottom: 0;
                padding: 10px;
                overflow: hidden;
            }
            .header-avator-con {
                height: 100%;
                width: calc(95% - 205px);
                margin-left: 5%;
                .switch-theme-con {
                    display: inline-block;
                    width: 40px;
                    height: 100%;
                }
                .message-con {
                    display: inline-block;
                    width: 30px;
                    padding: 18px 0;
                    text-align: center;
                    cursor: pointer;
                    i {
                        vertical-align: middle;
                    }
                }
                .btn-community-setting {
                    display: inline-block;
                    width: 40px;
                    padding: 18px 0;
                    text-align: center;
                    cursor: pointer;
                    i {
                        vertical-align: middle;
                    }
                }
                .change-skin {
                    font-size: 14px;
                    font-weight: 500;
                    padding-right: 5px;
                }
                .switch-theme {
                    height: 100%;
                }
                .user-dropdown {
                    &-menu-con {
                        display: flex;
                        ul {
                            height: 100%;
                            width: 70%;
                            li {
                                float: left;
                                height: @header-height;
                                line-height: @header-height;
                                position: relative;
                                cursor: pointer;
                                span {
                                    font-size: 18px;
                                    padding: 0 13px;
                                    display: inline-block;
                                    color: white;
                                    transition: transform .2s;
                                }
                            }
                            li span:hover {
                                transform: scale(1.1);
                            }
                        }
                        &-avatar {
                            height: @header-height;
                            line-height: @header-height;
                            display: flex;
                            width: 30%;
                            justify-content: flex-end;
                        }
                        .main-user-name {
                            display: inline-block;
                            width: 80px;
                            word-break: keep-all;
                            white-space: nowrap;
                            vertical-align: middle;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            text-align: right;
                        }
                        .ivu-btn {
                            color: #ffffff;
                            width: 90px;
                            height: 25px;
                            border: 1px solid white;
                            background: none;
                            line-height: 12.5px;
                        }
                        .ivu-btn:hover {
                            border: none;
                            background: white;
                            color: #8aaeff;
                        }
                    }
                    &-innercon {
                        height: 100%;
                        padding-right: 14px;
                    }
                }
                .full-screen-btn-con {
                    display: inline-block;
                    width: 30px;
                    padding: 18px 0;
                    text-align: center;
                    cursor: pointer;
                    i {
                        vertical-align: middle;
                    }
                }
                .lock-screen-btn-con {
                    display: inline-block;
                    width: 30px;
                    padding: 18px 0;
                    text-align: center;
                    cursor: pointer;
                    i {
                        vertical-align: middle;
                    }
                }
            }
        }
        .single-page-con {
            width: 100%;
            position: absolute;
            top: @header-height;
            left: 0;
            bottom: 0;
            z-index: 1;
            .single-page {
                /*padding: 0px 0 10px;*/
                height: 100%;
                box-sizing: border-box;
                overflow-y: hidden;
                overflow-x: hidden;
                &-bottom {
                    height: 5%;
                    margin-top: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .page {
                height: 100%;
                display: flex;
                flex-direction: column;
            }
        }
        &-copy {
            text-align: center;
            padding: 10px 0 20px;
            color: #9ea7b4;
        }
        .fault-list-con {
            position: absolute;
            right: 18px;
            bottom: 0;
            z-index: 55;
            width: 25%;
            height: auto;
            max-height: 80%;
            .fault-list {
                overflow-y: auto;
                overflow-x: hidden;
                height: auto;
                max-height: 550px;
                bottom: 0;
                right: 18px;
                width: 100%;
            }
        }
    }

    .taglist-moving-animation-move {
        transition: transform .3s;
    }

    .logo-con {
        padding: 8px;
        text-align: center;
        img {
            height: 44px;
            width: auto;
        }
    }

    .bar-detail {
        margin: 10px;
        height: 85%;
        overflow-y: auto;
    }

    .search-item {
        width: 100px;
    }

    .search-form {
        float: right;
    }

    .form-tag-container {
        border: 1px solid #dddee1;
        border-radius: 4px;
        color: #495060;
        background-color: #fff;
        padding: 0 4px;
    }

    .tree-menu-btn {
        display: none;
        cursor: pointer;
    }

    .tree-item:hover .tree-menu-btn {
        display: inline-block;
    }

    .ivu-tree-title.active {
        background-color: #fff;
        color: #aaa;
    }

    .ivu-dropdown-item.only-show {
        cursor: default;
    }

    .ivu-dropdown-item.only-show:hover {
        background-color: transparent;
    }

    /*left 菜单*/
    .main-left-menu {
        width: 200px;
        border-right: 1px solid #abafbd;
        height: 100%;
        margin-top: 60px;
        background: #92bafb;
        position: fixed;
        z-index: 200;
        color: #e3ebf0;
        transition: width .3s;
    }

    .guoji {
        display: inline-block;
        max-width: 80px;
        margin: 0 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-size: 16px;

    }

    .fade-enter-active, .fade-leave-active {
        transition: all 0.3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .personalInfo {
        position: fixed;
        width: 150px;
        height: 100%;
        right: 0px;
        top: 60px;
    }

    video {
        object-fit: fill;
        padding: 4px;
    }

    #save-videos {
        display: grid;
        grid-template-columns: 400px 400px 400px;
        grid-template-rows: 400px 400px 400px;
        border: 1px solid #000;
        justify-items: center;
    }

    .user-name {
        display: inline-block;
        max-width: 120px;
        margin: 0 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-size: 14px;
    }

    .user-info-head {
        cursor: pointer;
    }

    .language-box {
        color: #fff;
        cursor: pointer;
        margin: 0 15px;
    }

    .icon-status {
        width: 20%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        &-div {
            display: flex;
            color: #fff;
            align-items: center;
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
            position: relative;
            img {
                margin-top: 5px;
                width: 60px;
            }
            span {
                display: inline-block;
                position: absolute;
                right: 5px;
                width: 40%;
                text-align: center;
            }
        }
        &-box {
            cursor: pointer;
            margin: 0 20px;
        }
    }
</style>